import {Component, Input, OnInit} from '@angular/core';
import {Serializer} from "../../interfaces/serializer";
import {DataSource} from "../../interfaces/data-source";
import {DataSourceProvider} from '../../store/dataSourceProviders/dataSourceProviders';
import {DataExporterUsage} from "../../interfaces/data-exporter-usage";

@Component({
  selector: 'app-data-card',
  templateUrl: './data-card.component.html',
  styleUrls: ['./data-card.component.scss']
})
export class DataCardComponent implements OnInit {
  @Input('datasource') private set _setDatasource(item: Serializer<DataSource | DataSourceProvider | DataExporterUsage>) {
    switch (item.type) {
      case 'data_exporter':
        const exporter: Serializer<DataExporterUsage> = item as Serializer<DataExporterUsage>;

        this.name = exporter.attributes.name;
        this.icon = exporter.attributes.icon_small;
        break;
      case 'basic_data_source':
        {
          const dataSource: Serializer<DataSource> = item as Serializer<DataSource>;

          this.is_installable = dataSource.attributes.is_installable;
          this.is_new = dataSource.attributes.is_new;
          this.is_premium = dataSource.attributes.is_premium;
          this.icon = dataSource.attributes.icon_small;
          this.name = dataSource.attributes.name;
          this.color = dataSource.attributes.color;
        }
        break;
      case 'data_source_provider':
        {
          const dataSource: Serializer<DataSourceProvider> = item as Serializer<DataSourceProvider>;

          this.name = dataSource.attributes.name;
          this.icon = dataSource.attributes.icon;
        }
        break;
    }
  }

  public is_installable: boolean = true;
  public is_new: boolean;
  public is_premium: boolean;
  public in_development: boolean;
  public icon: string;
  public color: string;
  public name: string;

  constructor() { }

  ngOnInit(): void {
  }

}
